import TagsCell from "@via/components/tags-cell.tsx";
import ProcessRunAction from "@via/pages/pipelines/processes/process-run-action.tsx";
import type { ProcessCatalogItem } from "common";
import type { JSX } from "react";

interface ProcessTableProps {
  items: ProcessCatalogItem[];
  isGuest: boolean;
  onRun: (item: ProcessCatalogItem) => void;
  onOpen: (item: ProcessCatalogItem) => void;
}

export default function ProcessTable({
  items,
  isGuest,
  onRun,
  onOpen,
}: ProcessTableProps): JSX.Element {
  return (
    <div className="mt-6 overflow-x-auto rounded-lg bg-white drop-shadow-md">
      <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
        <thead className="bg-gray-50 text-xs font-semibold uppercase text-gray-500">
          <tr>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Description</th>
            <th className="px-4 py-3">Tags</th>
            <th className="px-4 py-3">Owner</th>
            <th className="px-4 py-3">
              <span className="sr-only">Run</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {items.map(item => (
            <tr
              key={item.id}
              data-testid={`process-row-${item.id}`}
              onClick={() => onOpen(item)}
              className="cursor-pointer hover:bg-gray-50">
              <td className="px-4 py-3 font-medium text-gray-900">
                <button
                  type="button"
                  onClick={event => {
                    event.stopPropagation();
                    onOpen(item);
                  }}
                  className="text-left font-medium text-gray-900 hover:text-indigo-600">
                  {item.name}
                </button>
              </td>
              <td className="max-w-md px-4 py-3 text-gray-500">
                <p className="line-clamp-2">{item.summary}</p>
              </td>
              <td className="px-4 py-3">
                <TagsCell tags={item.tags} rowId={item.id} variant="table" />
              </td>
              <td className="px-4 py-3 text-gray-500">{item.ownerName}</td>
              <td className="px-4 py-3 text-right">
                <ProcessRunAction item={item} isGuest={isGuest} onRun={onRun} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
